import React from 'react';
import { Box } from '@mui/material';
import { type TFunction } from 'i18next';

import { PlatformLocale, ProcessResponseDTOSendModesItem } from '@/api/generated';
import MailIcon from '@/assets/icons/mail.svg?react';
// import SmsIcon from '@/assets/icons/sms.svg?react';
// import WhatsappIcon from '@/assets/icons/whatsapp.svg?react';

export enum AccessMethods {
  Link = 'link',
  Otp = 'otp'
}

export enum WebcamMode {
  Mandatory = 'mandatory',
  Optional = 'optional',
  Disabled = 'disabled'
}

export const getWebcamRequiredOptions = (t: TFunction) => [
  { value: WebcamMode.Mandatory, label: t('processSettings.form.options.webcam.mandatory') },
  { value: WebcamMode.Optional, label: t('processSettings.form.options.webcam.optional') },
  { value: WebcamMode.Disabled, label: t('processSettings.form.options.webcam.no') }
];

export const getLanguageOptions = (t: TFunction) =>
  Object.keys(PlatformLocale).map(language => ({
    label: t(`common:common.languages.${language}`),
    value: language
  }));

export const getInvitationChannelOptions = (t: TFunction) => [
  {
    value: ProcessResponseDTOSendModesItem.EMAIL,
    label: t('processSettings.form.options.authMethods.email'),
    Icon: () => (
      <Box sx={{ '& .MailIcon-root': { width: 12, height: 12 } }}>
        <MailIcon className="MailIcon-root" />
      </Box>
    )
  }
  // {
  //   value: ProcessResponseDTOSendModesItem.TEXT_MESSAGE,
  //   label: t('processSettings.form.options.authMethods.sms'),
  //   Icon: () => (
  //     <Box sx={{ '& .SmsIcon-root': { width: 12, height: 12 } }}>
  //       <SmsIcon className="SmsIcon-root" />
  //     </Box>
  //   )
  // },
  // {
  //   value: ProcessResponseDTOSendModesItem.WHATSAPP,
  //   label: t('processSettings.form.options.authMethods.whatsapp'),
  //   Icon: () => (
  //     <Box sx={{ '& .WhatsappIcon-root': { width: 12, height: 12 } }}>
  //       <WhatsappIcon className="WhatsappIcon-root" />
  //     </Box>
  //   )
  // }
];

export const getAccessMethodOptions = (t: TFunction) => [
  { value: AccessMethods.Otp, label: t('processSettings.form.options.testAccess.otp') },
  { value: AccessMethods.Link, label: t('processSettings.form.options.testAccess.link') }
];
